"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Bell: function() {
        return Bell;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Bell = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.9999 3C8.69294 3 6.0108 5.67545 5.99997 8.97984C5.99996 8.98206 5.99995 8.98427 5.99992 8.98648C5.99998 8.9907 6.00001 8.99493 6.00001 8.99916C6.00316 12.7694 5.05982 15.4387 4.27951 17H9.00001H15H19.7206C18.9402 15.4387 17.9969 12.7694 18 8.99916C18 8.99721 18 8.99526 18 8.99331C18 8.98883 17.9999 8.98436 17.9999 8.97987C17.9891 5.67546 15.3069 3 11.9999 3ZM19.9999 8.98321C19.9999 8.97992 19.9999 8.97663 19.9999 8.97333C19.9855 4.56727 16.4093 1 11.9999 1C7.59057 1 4.01442 4.56725 3.99998 8.97328C3.99996 8.9789 3.99999 8.9845 4.00006 8.99009C4.00003 8.99367 4.00001 8.99725 4.00001 9.00084C4.00354 13.2178 2.70597 15.8335 2.07217 16.8612C1.78174 17.3322 1.82866 17.8657 2.02952 18.2505C2.23232 18.6391 2.66072 19 3.2483 19H8.00001C8.00001 21.2091 9.79087 23 12 23C14.2092 23 16 21.2091 16 19H20.7518C21.3394 19 21.7678 18.6391 21.9706 18.2505C22.1714 17.8657 22.2184 17.3322 21.9279 16.8612C21.2941 15.8335 19.9965 13.2178 20 9.00084C20 8.99495 20 8.98907 19.9999 8.98321ZM14 19H10C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19Z",
        fill: "currentColor"
    })
}), "Bell");
const _default = Bell;
